export enum ProjectDataViewModes {
  encodedData = "encoded-data",
  textData = "text-data",
  integrations = "integrations",
  oeCoding = "oe-coding",
  aiCoding = "ai-coding",
  datamap = "data-map",
  heatmap = "heat-map",
}
